module.exports = __webpack_public_path__ + "assets/img/cf6c32ff8d8c37e8b7ef561a1275bcb3.png";